"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redactEvent = exports.redactBreadcrumb = void 0;
var sentryRedaction_1 = require("./sentryRedaction");
Object.defineProperty(exports, "redactBreadcrumb", { enumerable: true, get: function () { return sentryRedaction_1.redactBreadcrumb; } });
Object.defineProperty(exports, "redactEvent", { enumerable: true, get: function () { return sentryRedaction_1.redactEvent; } });
